// extracted by mini-css-extract-plugin
export default {"buttonFile":"DatiPersonali_buttonFile__aeRs2"};